import { render, staticRenderFns } from "./ReporteTaller.vue?vue&type=template&id=156c0bcb&"
import script from "./ReporteTaller.vue?vue&type=script&lang=js&"
export * from "./ReporteTaller.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports